import classes from '../Pages.module.css';
import { Row, Col, Tabs, Skeleton, message } from 'antd';
import axios from 'axios';
import DataContext from '../../../Context/dataContext';
import { useState, useEffect, useContext } from 'react';
import BasicSalaryAdvanceDetails from './BasicSalaryAdvanceDetails';
import AdvanceFormDetails from './AdvanceFormDetails';
import { useNavigate } from 'react-router';
import SyncLoader from "react-spinners/SyncLoader";

const { TabPane } = Tabs;

const AdvanceFormCreate = (props) => {

  const employeeData = useContext(DataContext)
  const history = useNavigate();

  const [ad, setAD] = useState(null)
  const [loading, setLoading] = useState(false)
  const [editMode, setEditMode] = useState(true)
  const [allData, setAllData] = useState({
    "header": {
      "metaData": [
        {
          "name": "emp_cd"
        },
        {
          "name": "adv_month"
        },
        {
          "name": "adv_year"
        },
        {
          "name": "adv_amount"
        },
        {
          "name": "card_no"
        }
      ],
      "rows": [
        {
          "emp_cd": null,
          "adv_month": null,
          "adv_year": null,
          "adv_amount": null,
          "card_no": null
        }
      ]
    },
    "details": {
      "metaData": [
        {
          "name": "paid_month"
        },
        {
          "name": "paid_year"
        },
        {
          "name": "amount"
        }
      ],
      "rows": []
    }
  });


  useEffect(() => {

    setAD(null)
    axios
      .get(employeeData.URL + '/api/v1/norms/salary-advance/additional-data', {
        withCredentials: true
      })
      .then((response) => {

        console.log(response);
        setAD(ad => {
          let newad = response.data.data
          return ({
            ...newad,

          });
        })
      })
      .catch((error) => {
        console.log(error);
      })

  }, [])

  // const handleSave = (event) => {

  //   var formv = true
  //   let count = 0;
    
  //   console.log(allData,"all data is this");
  //   const header = allData.header.rows[0];
   

  //   if(!header?.emp_cd || !header?.adv_month || !header?.adv_year || !header?.adv_amount){
  //     message.error({
  //       content: "Please Fill the Mandatory Fields in header!!!",
  //       className: "custom-class",
  //       style: { marginTop: "1vh" },
  //     });
     
  //   }


   
  //   allData.details.rows.forEach(data => {

  //     if (!data) {

  //       formv = formv && false
  //       if (count === 0) {
  //         message.error({
  //           content: 'Empty Fields In Salary DETAILS Tab!!!',
  //           className: 'custom-class',
  //           style: {
  //             marginTop: '1vh',
  //           },
  //         });
  //       }

  //       count = count + 1;
  //     }
  //   })

  //   if (formv) {

  //     console.log("Submitting");

  //     const postData = {
  //       "header": allData.header.rows,
  //       "details": allData.details.rows,
  //     }

  //     console.log(JSON.stringify(postData, undefined, 2));
  //     setLoading(true)
  //     axios
  //       .post(employeeData.URL + '/api/v1/norms/salary-advance', postData, {
  //         withCredentials: true,
  //         credentials: 'include',
  //       })
  //       .then((response) => {
  //         message.success({
  //           content: 'salary advance Created Successfully!!!',
  //           className: 'custom-class',
  //           style: {
  //             marginTop: '2vh',
  //           },
  //         });
  //         setLoading(false)
  //         history('/payroll/norms/salary-advance')
  //       })
  //       .catch((err) => {
  //         message.error({
  //           content: 'An Error Occurred!!!!',
  //           className: 'custom-class',
  //           style: {
  //             marginTop: '2vh',
  //           },
  //         });
  //         setLoading(false)
  //       });
  //   }

  // }

  const handleSave = (event) => {
    console.log(allData, "all data is this");
    const header = allData.header.rows[0];
  
    // Check if mandatory fields in the header are filled
    if (!header?.emp_cd || !header?.adv_month || !header?.adv_year || !header?.adv_amount) {
      message.error({
        content: "Please Fill the Mandatory Fields in header!!!",
        className: "custom-class",
        style: { marginTop: "1vh" },
      });
      return; // Stop execution if header fields are not filled
    }
  
    // Check if details rows are empty
    if (allData.details.rows.length === 0) {
      message.error({
        content: "Details Tab Cannot Be Empty!!!",
        className: "custom-class",
        style: { marginTop: "1vh" },
      });
      return; // Stop execution if details rows are empty
    }
  
    let formv = true; // Assume the form is valid initially
    let count = 0; // Reset count before the loop
  
    // Check each row in the details tab
    allData.details.rows.forEach((data) => {
      // Check if any required field in the row is empty
      if (!data?.paid_month || !data?.paid_year || !data?.amount) {
        formv = false; // Set form validity to false
        if (count === 0) {
          message.error({
            content: "Empty Fields In Salary Advance DETAILS Tab!!!",
            className: "custom-class",
            style: {
              marginTop: "1vh",
            },
          });
        }
        count = count + 1; // Increment count to prevent multiple messages
      }
    });
  
    // If form is valid, submit the data
    if (formv) {
      console.log("Submitting");
  
      const postData = {
        header: allData.header.rows,
        details: allData.details.rows,
      };
  
      console.log(JSON.stringify(postData, undefined, 2));
      setLoading(true);
      axios
        .post(employeeData.URL + "/api/v1/norms/salary-advance", postData, {
          withCredentials: true,
          credentials: "include",
        })
        .then((response) => {
          message.success({
            content: "Salary Advance Created Successfully!!!",
            className: "custom-class",
            style: {
              marginTop: "2vh",
            },
          });
          setLoading(false);
          history("/payroll/norms/salary-advance");
        })
        .catch((err) => {
          message.error({
            content: "An Error Occurred!!!!",
            className: "custom-class",
            style: {
              marginTop: "2vh",
            },
          });
          setLoading(false);
        });
    }
  };

  const handleCancel = (event) => {

    setLoading(false)
    history('/payroll/norms/salary-advance')
  }
  return (
    ad
      ?
      <Row className={classes['RowP']}>
        <Col lg={editMode ? 13 : 19} md={editMode ? 13 : 19} className={classes['Col']} >

        </Col>
        {
          editMode
            ?
            <>
              <Col md={4} >
                {
                  loading
                    ?
                    <SyncLoader color={"rgba(255,163,77,0.8)"} size={10} />
                    :
                    <button
                      style={{
                        padding: "7px 30px 14px 24px",
                        borderRadius: "50px",
                        background: "transparent",
                        width: "100%",
                        border: "none",
                        outline: "none",
                        fontSize: "16px",
                        fontWeight: "600",
                        lineHeight: "1.5",
                        color: "#071e54",
                        WebkitAppearance: "none",

                        boxShadow:
                          "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff", // Original box shadow
                        height: "40px",

                        // Ensure the button takes full width
                      }}
                      onClick={(event) => handleSave(event)}
                      className={classes["ProfileButtonn"]}
                      id="save"
                      onMouseOver={(event) => {
                        event.target.style.boxShadow = "0px 5px 15px 0px #264a9f"; // Apply spread color on hover with 0 spread at the top
                      }}
                      onMouseOut={(event) => {
                        event.target.style.boxShadow =
                          "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff"; // Restore original shadow on mouse out
                      }}
                    >
                      Save
                    </button>
                }

              </Col>
              <Col md={4} >
                {
                  loading
                    ?
                    <SyncLoader color={"rgba(255,163,77,0.8)"} size={10} />
                    :
                    <button
                      style={{
                        padding: "7px 30px 14px 24px",
                        borderRadius: "50px",
                        background: "transparent",
                        width: "100%",
                        border: "none",
                        outline: "none",
                        fontSize: "16px",
                        fontWeight: "600",
                        lineHeight: "1.5",
                        color: "#071e54",
                        WebkitAppearance: "none",

                        boxShadow:
                          "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff", // Original box shadow
                        height: "40px",

                        // Ensure the button takes full width
                      }}
                      onClick={(event) => handleCancel(event)}
                      onMouseOver={(event) => {
                        event.target.style.boxShadow = "0px 5px 15px 0px #264a9f"; // Apply spread color on hover with 0 spread at the top
                      }}
                      onMouseOut={(event) => {
                        event.target.style.boxShadow =
                          "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff"; // Restore original shadow on mouse out
                      }}
                      className={classes["ProfileButtonn"]}
                    >
                      Cancel
                    </button>
                }
              </Col>
            </>
            :
            <Col md={4} >
              <button onClick={() => setEditMode(true)} className={classes['ProfileButton']}>Edit Details</button>
            </Col>
        }
        <Col lg={1} md={1} >

        </Col>
        <Col lg={24} md={24} className={classes['Col']}>
          <p></p>
          <div className={classes['EditView']}>
           
                <BasicSalaryAdvanceDetails create={true} ad={ad} setData={setAllData} data={allData.header.rows[0]} editMode={editMode} />
                <Tabs
              centered
              tabPosition="top"
              style={{ display: "flex", justifyContent: "center" }}
            >
                <TabPane tab={<span>Salary Advance Detail</span>} key="0" type="line">
                <AdvanceFormDetails ad={ad} editMode={editMode} setData={setAllData} data={allData.details.rows} />
              </TabPane>
            </Tabs>
          </div>
        </Col>
      </Row>
      :
      <>
        <Skeleton active={true} />
        <Skeleton active={true} />
        <Skeleton active={true} />
      </>
  );
}

export default AdvanceFormCreate;